export class AuctionScheduleDTO{
    
    public seqNo!:number;
    public auctionStarting?:string;
    public auctionEnding?:string;
    public autoRenewTimes?:number;
    public autoRenewDays?:number;
    public noMinimumBid:boolean = false;
    public previousAuctionEnding?:string;
    public scheduleEnded:boolean = false;
    public wasNeverLive:boolean = false;
    public reserveCredit?:number;
    public timeZoneOffsetMinutes?:number;
    public postponed:boolean = false;
    public showPostponed:boolean = false;

    constructor(){
    }
}